module.exports = __webpack_public_path__ + "img/mehtalla.7535523a.jpeg";